import { render, staticRenderFns } from "./BasePreloader.vue?vue&type=template&id=2750f8ba&scoped=true&"
import script from "./BasePreloader.vue?vue&type=script&lang=js&"
export * from "./BasePreloader.vue?vue&type=script&lang=js&"
import style0 from "./BasePreloader.vue?vue&type=style&index=0&id=2750f8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750f8ba",
  null
  
)

export default component.exports